import React, { useState, Fragment } from "react";
import { useOutsideClick } from "../Components/useOutsideClick";

const Navigation = ({links=[], contentLink=null }) => {
    let menuRef = React.createRef();
    const onOutsideClick = () => {
        if(menuVisible === true) {
            setMenuVisible(false);
            document.body.classList.remove('add-overlay');
        }
    }
    const [menuVisible, setMenuVisible] = useState(false);
    useOutsideClick(menuRef, onOutsideClick);

    const additionClass = contentLink && contentLink.attributes ? contentLink.attributes.cssValue : null;
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = link => link.name || (link.links || []).length > 0;

    return (
    <Fragment>
        {!contentLink ? (
            <a className="navbar__link--block navbar__icon--menu navbar__icon" ></a>
        ) : (
            <Fragment>
                {contentLink.name && 
                <>
                    <a className={`navbar__link ${hasChildrenClass || '' } ${additionClass || ''}`} 
                        href={contentLink.url||'#'} dangerouslySetInnerHTML={{__html: contentLink.name}} >
                    </a>
                    {links.length > 0 &&
                    <i className="navbar__icon--caret-right navbar__icon navbar__icon--open"></i>
                    }
                </>
                }
            </Fragment>
        )}

        { links.length > 0 &&
            <ul className={menuVisible ? "navbar__menu--show navbar__menu": "navbar__menu"} ref={menuRef} test={links.length}>
                    {!contentLink ? (
                        <div className="navbar__menu-header">
                            <span className="navbar__icon navbar__icon--close"></span>
                        </div>
                    ) : (
                        <Fragment>
                            {contentLink.name &&
                            <>
                                <div className="navbar__menu-header">
                                    <i className="navbar__icon--caret-left navbar__icon"></i>
                                    <span className="navbar__title" dangerouslySetInnerHTML={{__html: contentLink.name}}></span>
                                </div>
                            </>
                            }
                        </Fragment>
                    )}
                {links.length > 0 && links.map((link, i) => hasNameOrChildren(link) &&
                    <li className="navbar__item" key={!link.name ? `${new Date().getTime()}-${i}` : `${link.name}-${i}`}>
                        <Navigation links={link.links} contentLink={link}/>
                    </li>
                )}
            </ul>
        }
        
    </Fragment>
)}

export default Navigation;